<template>
    <div class="exhibition-extra">
        <div class="wrapper">
            <img src="/image/extra/big.png" alt="">
            <div class="swiper-box">
                <swiper
                    :options="swiperOption">
                    <swiper-slide v-for="(item) in imgs" :key="item">
                        <div class="swiper-img-box" @click="handleClick(item)">
                            <img class="swiper-img"
                                 :src="item"
                                 alt=""/>
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="swiper-button-prev"></div><!--左箭头。如果放置在swiper外面，需要自定义样式。-->
                <div class="swiper-button-next"></div>
            </div>
        </div>
        <el-dialog
            title=""
            :visible.sync="dialogVisible"
            width="500px">
            <img style="width: 500px;" :src="currentImg" alt=""/>
        </el-dialog>    
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css'; 
const imgs = ref([
    '/image/extra/1/01.jpg',
    '/image/extra/1/02.jpg',
    '/image/extra/1/03.jpg',
    '/image/extra/1/04.jpg',
    '/image/extra/1/05.jpg',
    '/image/extra/1/06.jpg',
    '/image/extra/1/07.jpg',
    '/image/extra/1/08.jpg',
    '/image/extra/2/01.jpg',
    '/image/extra/2/02.jpg',
    '/image/extra/2/03.jpg',
    '/image/extra/2/04.jpg',
    '/image/extra/2/05.jpg',
    '/image/extra/3/01.jpg',
    '/image/extra/3/02.jpg',
    '/image/extra/3/03.jpg',
    '/image/extra/3/04.jpg',
    '/image/extra/3/05.jpg',
    '/image/extra/4/01.jpg',
    '/image/extra/4/02.jpg',
    '/image/extra/4/03.jpg',
    '/image/extra/4/04.jpg',
    '/image/extra/4/05.jpg',
    '/image/extra/5/01.jpg',
    '/image/extra/5/02.jpg',
    '/image/extra/5/03.jpg',
    '/image/extra/5/04.jpg',
    '/image/extra/5/05.jpg',
    '/image/extra/6/01.jpg',
    '/image/extra/6/02.jpg',
    '/image/extra/6/03.jpg',
    '/image/extra/6/04.jpg',
    '/image/extra/6/05.jpg'
]);
const dialogVisible = ref(false);
const swiperIndex = ref(0);
const swiperOption = {
    loop: true,
    autoplay: true,
    // 展示 3 张
    slidesPerView: 3,
    spaceBetween: 10,
    centeredSlides: true,
    simulateTouch: false, 
    on: {
        // slideChange: function () {
        //     swiperIndex.value = this.activeIndex;
        // },
        click: function () {
            dialogVisible.value = true;
            swiperIndex.value = this.activeIndex;
        }
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        clickable: true
    }
};
const currentImg = ref('');
const handleClick = (item) => {
    dialogVisible.value = true;
    currentImg.value = item;
};
onMounted(() => {
   
});
</script>

<style scoped lang="scss">
.exhibition-extra {
    .wrapper {
        width: 1440px;
        height: 100%;
        margin: 0 auto;
        img {  
            width: 100%;
           
        }
       
        .swiper-img {
            background: #E9E3DB;
            width: 470px;
        }
        .swiper-box {
            position: relative;
            .swiper-img-box {
               filter: blur(4px);
            }
            :deep(.swiper-slide-active) {
                .swiper-img-box {
                    filter: blur(0px);
                }
            }
            .swiper-button-prev {
                display: none;
                height: 40px;
            }
            .swiper-button-next {
                display: none;
                height: 40px;
            }
            &:hover {
                .swiper-button-prev {
                    display: block;
                }
                .swiper-button-next {
                    display: block;
                }
            }
            
        }
    }
    :deep(.el-dialog__header) {
        padding: 0;
    }
    :deep(.el-dialog__body) {
        padding: 0;
        font-size: 0;
    }
}
</style>